export const UNASSIGNED_ITEMS_ID = 'unassigned-items';
export const PACKAGE_ID_PREFIX = 'package-';
export const DRAGGABLE_ID_SEPARATOR = '::';
